module.exports = __webpack_public_path__ + "static/media/fx-page1.c4903ab7.png";